import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { GLOBAL_VARIABLES } from "./emailTemplateUtils";

export default function VariableInsertDropdown({ variables, onInsert, disabled }) {
  const { t } = useTranslation();

  const availableVariables = (variables?.length ? variables : GLOBAL_VARIABLES.map((v) => v.key)).map(
    (key) => GLOBAL_VARIABLES.find((v) => v.key === key) || { key, label: key }
  );

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="outline-secondary"
        size="sm"
        disabled={disabled}
      >
        <i className="bi bi-braces me-1" />
        {t("Insert variable")}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {availableVariables.map(({ key, label }) => (
          <Dropdown.Item key={key} onClick={() => onInsert(key)}>
            <code className="me-1">{key}</code>
            <span className="text-muted small">{t(label)}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
